import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Check consent on page load
    this.updateConsent()

    // Listen for consent changes
    window.addEventListener('cookieConsentChanged', this.handleConsentChange.bind(this))
  }

  disconnect() {
    window.removeEventListener('cookieConsentChanged', this.handleConsentChange.bind(this))
  }

  handleConsentChange(event) {
    const preferences = event.detail
    this.applyConsent(preferences)
  }

  updateConsent() {
    const consentData = localStorage.getItem('cookieConsent')

    if (consentData) {
      try {
        const preferences = JSON.parse(consentData)
        this.applyConsent(preferences)
      } catch (e) {
        console.error('Error parsing cookie consent:', e)
      }
    }
  }

  applyConsent(preferences) {
    if (typeof gtag === 'undefined') {
      console.warn('Google Tag Manager not loaded yet')
      return
    }

    // Update consent based on user preferences
    // Analytics for Google Analytics, ad_storage disabled (no marketing)
    const consentUpdate = {
      'analytics_storage': preferences.analytics ? 'granted' : 'denied',
      'ad_storage': 'denied',
      'ad_user_data': 'denied',
      'ad_personalization': 'denied'
    }

    gtag('consent', 'update', consentUpdate)

    // Push event to dataLayer for debugging
    if (window.dataLayer) {
      window.dataLayer.push({
        'event': 'consent_updated',
        'consent_preferences': preferences
      })
    }
  }
}
